import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Stars from './Stars';
import { getImageUrl } from '../../config/runtime';

export default function ReviewCard({ review, onEdit, onDelete }) {
  const [expanded, setExpanded] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  useEffect(() => {
    const onDocClick = (e) => {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    if (menuOpen) document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [menuOpen]);
  const user = review.user || {};
  const visited = review.visitedAt ? new Date(review.visitedAt) : null;
  const showEdit = typeof onEdit === 'function';
  const showDelete = typeof onDelete === 'function';
  const isEdited = review.updatedAt && review.createdAt && (new Date(review.updatedAt).getTime() - new Date(review.createdAt).getTime() > 1000);
  const sourceProjectId = (() => {
    try {
      const tag = (review.tags || []).find(t => typeof t === 'string' && t.startsWith('_src:'));
      return tag ? tag.slice(5) : null;
    } catch (_) {
      return null;
    }
  })();
  const visibleTags = (review.tags || []).filter(t => typeof t === 'string' && !t.startsWith('_'));

  return (
    <div className="border-b border-gray-200 dark:border-gray-700 py-10">
      <div className="flex items-start gap-3">
        <div className="w-12 h-12 rounded-full overflow-hidden bg-gradient-to-r from-blue-600 to-purple-600 flex items-center justify-center text-white text-xs font-bold">
          {user.avatar ? (
            <img src={getImageUrl(user.avatar)} alt={user.username} className="w-full h-full object-cover" />
          ) : (
            <span>{(user.firstName?.[0] || user.username?.[0] || '?').toUpperCase()}</span>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <div className="min-w-0">
              <div className="text-base font-semibold text-gray-900 dark:text-white truncate">{user.username ? `@${user.username}` : 'User'}</div>
              <div className="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400 mt-1">
                <Stars value={review.rating} size={14} />
                {visited && <span>{visited.toLocaleDateString()}</span>}
                {isEdited && <span>· Edited</span>}
              </div>
            </div>
            {(showEdit || showDelete) && (
              <div ref={menuRef} className="relative">
                <button
                  onClick={() => setMenuOpen((v) => !v)}
                  className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300"
                  aria-haspopup="menu"
                  aria-expanded={menuOpen}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg>
                </button>
                {menuOpen && (
                  <div className="absolute right-0 mt-2 w-40 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg z-10" role="menu">
                    {showEdit && (
                      <button onClick={() => { setMenuOpen(false); onEdit(review); }} className="w-full text-left px-3 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700">Edit review</button>
                    )}
                    {showDelete && (
                      <button onClick={() => { setMenuOpen(false); onDelete(review); }} className="w-full text-left px-3 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-gray-700">Delete review</button>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div>
        <div>
          {visibleTags.length ? (
            <div className="mt-4 flex flex-wrap gap-1">
              {visibleTags.map((t, i) => (
                <span key={i} className="px-2.5 py-1 rounded-lg text-gray-600 dark:text-gray-300 text-xs border border-gray-200 dark:border-gray-600/50">{t}</span>
              ))}
            </div>
          ) : null}

          {review.comment ? (
            <div className="mt-4 text-regular text-gray-800 dark:text-gray-200 leading-relaxed">
              {expanded ? review.comment : (review.comment.length > 220 ? `${review.comment.slice(0, 220)}…` : review.comment)}
              {review.comment.length > 220 && (
                <button className="ml-2 text-blue-600 dark:text-blue-400" onClick={() => setExpanded(v => !v)}>
                  {expanded ? 'Show less' : 'Read more'}
                </button>
              )}
            </div>
          ) : null}

          {/* {review.difficulty ? (
            <div className="mt-2 text-xs text-gray-600 dark:text-gray-400">
              Difficulty: <span className="px-2 py-0.5 rounded-full bg-gray-100 dark:bg-gray-700">{review.difficulty[0].toUpperCase() + review.difficulty.slice(1)}</span>
            </div>
          ) : null} */}
        </div>
      </div>
      {sourceProjectId && (
        <div className="mt-6">
          <Link to={`/projects/${sourceProjectId}`} className="text-sm text-blue-600 dark:text-blue-400 hover:underline">Show project</Link>
        </div>
      )}
    </div>
  );
}


